import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';

import {EmailSignatureContainer} from './email-signature-container';

export function mountEmailSignature() {
    const emailSignatureContainer = document.querySelector('#react-mount-email-signature');
    if (emailSignatureContainer) {
        ReactDOM.render(
            <ApolloProvider client={nutApolloClient}>
                <ReactHooksApolloProvider client={nutApolloClient}>
                    <EmailSignatureContainer />
                </ReactHooksApolloProvider>
            </ApolloProvider>,
            emailSignatureContainer
        );
    }
}
